import type { ReactNode } from "react";
import { TimeIcon } from "../../icons/TimeIcon";
import { Text } from "../../typography";
import { classNames } from "../../utils";
import { type ComparisonSide, changedValueClassName, valueIntent } from "./comparison";

type TimeBadgeProps = {
	side?: ComparisonSide;
	changed?: boolean;
	children: ReactNode;
};

export const TimeBadge = ({ side, changed = false, children }: TimeBadgeProps) => (
	<div
		className={classNames(
			"flex items-center gap-2 rounded-md px-2 py-1",
			side === "after" && changed ? "border border-success bg-success-faded" : "bg-neutral-faded",
			changedValueClassName(side, changed),
		)}
	>
		<TimeIcon className="size-3 min-h-3 min-w-3" />
		<Text size="xs" intent={valueIntent(side)}>
			{children}
		</Text>
	</div>
);
